/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_Load_FailInputs */

const en_roster_load_fail = /** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load roster`)
};

const es_roster_load_fail = /** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar la lista`)
};

const fr_roster_load_fail = /** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement de la liste`)
};

const de_roster_load_fail = /** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Teilnehmerliste`)
};

const id_roster_load_fail = /** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memuat daftar hadir`)
};

/** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */
const ja_roster_load_fail = en_roster_load_fail;

/** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */
const zh_roster_load_fail = en_roster_load_fail;

/** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */
const ar_roster_load_fail = en_roster_load_fail;

/** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */
const it_roster_load_fail = en_roster_load_fail;

/** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */
const ru_roster_load_fail = en_roster_load_fail;

/** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */
const pt_roster_load_fail = en_roster_load_fail;

/** @type {(inputs: Roster_Load_FailInputs) => LocalizedString} */
const ko_roster_load_fail = en_roster_load_fail;

/**
* | output |
* | --- |
* | "Failed to load roster" |
*
* @param {Roster_Load_FailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_load_fail = /** @type {((inputs?: Roster_Load_FailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_Load_FailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_load_fail(inputs)
	if (locale === "es") return es_roster_load_fail(inputs)
	if (locale === "fr") return fr_roster_load_fail(inputs)
	if (locale === "de") return de_roster_load_fail(inputs)
	if (locale === "ja") return ja_roster_load_fail(inputs)
	if (locale === "zh") return zh_roster_load_fail(inputs)
	if (locale === "ar") return ar_roster_load_fail(inputs)
	if (locale === "id") return id_roster_load_fail(inputs)
	if (locale === "it") return it_roster_load_fail(inputs)
	if (locale === "ru") return ru_roster_load_fail(inputs)
	if (locale === "pt") return pt_roster_load_fail(inputs)
	return ko_roster_load_fail(inputs)
});